import { useTRPCAPI, useTRPCQuery } from '../../../trpc/trpc';
import { useShareTokenInput } from './useShareTokenInput';
import { useSMLCountryParam } from './useSMLCountryParam';

interface UseArtistPositionChangeProps {
  artistId: string;
  date?: Date;
  rangeDays?: number;
}

export const useArtistPositionChange = ({ artistId, date, rangeDays }: UseArtistPositionChangeProps) => {
  const trpcMusicAPI = useTRPCAPI();
  const shareTokenInput = useShareTokenInput();
  const { countryCode } = useSMLCountryParam();

  const positionChangeQuery = useTRPCQuery(
    trpcMusicAPI.artists.positionChange.queryOptions({
      artistId,
      date,
      rangeDays,
      // Public share links pin the global view.
      countryCode: shareTokenInput.shareToken !== undefined ? undefined : countryCode,
      ...shareTokenInput,
    })
  );

  return positionChangeQuery;
};
